import { AuthError } from "@azure/msal-common";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import React from "react";
import { ExclamationOctagonFill } from "react-bootstrap-icons";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles({
  main: {
    color: "#d70443",
    backgroundColor: "#fff9f9",
    border: "1px solid #d70443",
    width: "340px",
    padding: "20px 30px",
    margin: "30px auto 0",
    borderRadius: "3px",
    textAlign: "left",
    fontFamily: "Lato",
    clear: "both",
  },
  title: { fontSize: "20px", fontWeight: 700, marginBottom: "10px" },
  description: {
    color: "#323232",
    fontSize: "16px",
    fontWeight: 400,
  },
  icon: { marginTop: "5px" },
});

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ErrorPage({ error }: { error: AuthError | null}) {
  const classes = useStyles();
  let query = useQuery();

  const errorDescription = (error?.errorMessage || query.get("error_description")) ?? "No details are available.";

  const title = "You cannot access this site.";
  const description = "Talk to your manager and refer to Scoop for instructions on how to request the proper access.";
  const detail = `Error details: ${errorDescription}`;

  return (
    <>
      <Box className={classes.main}>
        <Grid container spacing={2}>
          <Grid item xs={1}>
            <ExclamationOctagonFill className={classes.icon} />
          </Grid>
          <Grid item xs={11}>
            <Box className={classes.title}>{title}</Box>
            <Box className={classes.description}>{description}</Box>
            <Box className={classes.description}>{detail}</Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default ErrorPage;
